import React, { useEffect, useState } from 'react';
import { useCustomer } from '../../context/CustomerContext';
import { getMyLoyalty } from '../../services/medusa/loyalty';
import './PointsPanel.css';

const REASON_LABELS = {
  purchase: 'Compra',
  adjustment: 'Ajuste',
  redemption: 'Canje',
};

function formatDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d)) return '';
  return d.toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' });
}

export default function PointsPanel({ socioId }) {
  const { token } = useCustomer() || {};
  const [data, setData] = useState({ loading: true, balance: 0, transactions: [], error: '' });

  useEffect(() => {
    if (!token) {
      setData((d) => ({ ...d, loading: false }));
      return;
    }
    let cancelled = false;
    getMyLoyalty(token)
      .then((r) => {
        if (!cancelled) setData({ loading: false, balance: r.balance || 0, transactions: r.transactions || [], error: '' });
      })
      .catch((err) => {
        if (!cancelled) setData({ loading: false, balance: 0, transactions: [], error: err.message || 'No se pudieron cargar tus puntos.' });
      });
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="pts-panel">
      {/* Carnet: No. de socio + saldo */}
      <div className="pts-card">
        <div className="pts-card__brand">PHYSIOLOGY · Socia</div>
        <div className="pts-card__row">
          <div>
            <div className="pts-card__label">No. de socia</div>
            <div className="pts-card__socio">{socioId || '——————'}</div>
          </div>
          <div className="pts-card__balance">
            <div className="pts-card__label">Puntos</div>
            <div className="pts-card__points">{data.loading ? '—' : data.balance.toLocaleString('es-MX')}</div>
          </div>
        </div>
        {/* QR pendiente de definir propósito: por ahora, placeholder visual. */}
        <div className="pts-card__qr" aria-hidden="true" title="Código de socia (próximamente)">
          <span>QR</span>
        </div>
      </div>

      <p className="pts-note">
        Ganas puntos con cada compra. Pronto podrás canjearlos por recompensas.
      </p>

      {/* Historial */}
      <h3 className="pts-history-title">Historial de puntos</h3>
      {data.loading ? (
        <p className="pts-muted">Cargando…</p>
      ) : data.error ? (
        <p className="pts-muted">{data.error}</p>
      ) : data.transactions.length === 0 ? (
        <p className="pts-muted">Aún no tienes movimientos. Tu primera compra empieza a sumar.</p>
      ) : (
        <ul className="pts-list">
          {data.transactions.map((t) => (
            <li key={t.id} className="pts-item">
              <div className="pts-item__main">
                <span className="pts-item__reason">{REASON_LABELS[t.reason] || t.reason}</span>
                {t.note && <span className="pts-item__note">{t.note}</span>}
              </div>
              <div className="pts-item__side">
                <span className={`pts-item__points ${Number(t.points) < 0 ? 'is-neg' : 'is-pos'}`}>
                  {Number(t.points) > 0 ? '+' : ''}{Number(t.points).toLocaleString('es-MX')}
                </span>
                <span className="pts-item__date">{formatDate(t.date)}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
